<template>
    <div class="content">
        <h2>预约成功，请做好检前准备！</h2>
        <h3>【体检须知】</h3>
        <ul>
            <li>1.	体检前一日最好禁食牛奶、豆制品、糖类等食品，防止影响B超检查结果，体检当日请勿饮水、服药（降压药除外），禁食早餐。</li>
            <li>2.	糖尿病或其他慢性病患者，应随身携带药物，以便空腹项目结束后及时服用，以免耽误常规治疗。</li>
            <li>3.	下腹部超声（膀胱、前列腺、子宫附件）检查时，请在服务人员的指导下喝温开水，让膀胱充盈，便于检查。但阴超检查前先排空膀胱，便于检查。</li>
            <li>4.	怀孕的或备孕女性禁做放射检查。</li>
            <li>5.	体检报到时间：早上7：15至9：00之间，体检完毕请将体检指单交至服务台并领取早餐劵。</li>
            <li>6.	体检当天请带好个人身份证件，勿携带贵重物品、勿穿着连体衣裤及长筒靴。</li>
            <li>7.	体检必须在指定时间内进行，如有特殊情况，需另约时间方可体检。</li>
        </ul>
        <div class="btns">
            <div @click="gohome"  class="no">返回</div>
           
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id: 1
            }
        },
        methods: {
            yuyue() {
                this.$router.push('/user/orderyuyue')
                return false;
            },
            gohome(){
                this.$router.replace('/shoplist')
                // this.$router.back(-1);
                // this.$router.push('/');
                // return false;
            }
        },
    }
</script>

<style scoped lang='less'>
.content{
    padding: 1em 1em;
}
    h4 {
        color: #43852E;
        font-size: 1rem;
        padding-top: 30%;
    }
    h2,
    h4 {
        text-align: center;
        color: #FF5500;
        font-weight: normal;
    }
    h2 {
        font-size: 1.5rem;
        font-weight: normal;
        
    }
    li{
        font-size: 0.8rem;
        line-height: 1.5em;
    }
    h3{
        color: #FF5500;
        font-size: 1rem;
        font-weight: normal;
    }
    .btns
    {
        padding-top: 4em;
        text-align: center;
        >div{
            display: inline-block;
            font-size: 1rem;
            line-height: 2.5em;
            height: 2.5em;
            border: 1px solid #43852E;
            width: 8em;
            text-align: center;
            background: #43852E;
            color: #fff;
            border-radius: 10px;
        }
        .no{
            background: #fff;
            color: #43852E;
            margin-right: 1em;
            color: #fff;
            background: #43852E;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/yuyueSuccess.vue